<template>
  <v-card class="overflow-hidden fill-height" color="transparent">
    <v-card-text class="fill-height">
      <div class="report-content-wrapper fill-height text-body-2 text-sm-body-1">
        <v-row :class="$vuetify.breakpoint.xsOnly ? 'flex-column-reverse' : ''">
          <v-col cols="12" sm="7">
            <v-row align="center" class="fill-height" no-gutters>
              <div>
                <section-header v-if="$vuetify.breakpoint.smAndUp" class="mb-5">
                  {{ $t(`reports.${category}`) }}
                </section-header>

                <p>{{ $t('reports.culture_instructions.1') }}</p>
                <p v-if="selectedPersonnelSurvey" v-html="$t('reports.culture_instructions.2')"></p>
                <p v-if="selectedManagementSurvey" v-html="$t('reports.culture_instructions.3')"></p>

                <basic-button class="mt-4 ml-n2 px-2" color="primary" text @click="goToCategory">
                  {{ $t(`reports.open_report`) }}
                </basic-button>
              </div>
            </v-row>
          </v-col>
          <v-col cols="12" sm="5">
            <section-header v-if="$vuetify.breakpoint.xsOnly" class="mb-5">
              {{ $t(`reports.${category}`) }}
            </section-header>
            <div :class="$vuetify.breakpoint.smAndUp ? 'fill-height' : ''" class="py-4">
              <v-row class="flex-row align-center justify-center fill-height" no-gutter>
                <v-fade-transition hide-on-leave>
                  <div class="culture-chart-holder" v-if="personnelSurvey">
                    <company-culture-chart :calculation="personnelSurvey.calculation" />
                  </div>
                </v-fade-transition>
                <v-fade-transition hide-on-leave>
                  <v-progress-circular
                    v-if="managementValue > -1 && !personnelSurvey"
                    size="220"
                    width="30"
                    :color="$getScoreColor(managementValue, scale)"
                    :value="managementValue"
                  >
                    <span class="text-h2 font-weight-bold">{{ managementValue }}%</span>
                  </v-progress-circular>
                </v-fade-transition>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import BasicButton from '@/components/BasicButton';
import SectionHeader from '@/components/SectionHeader';
import categoryService from '@/service/category.service';
import CompanyCultureChart from '@/components/Tenant/Dashboard/CompanyCultureChart';

import { sum } from 'mathjs';

export default {
  name: 'ReportCultureCard',
  components: { CompanyCultureChart, SectionHeader, BasicButton },
  props: ['surveys', 'category'],
  data() {
    return {
      scale: [22.5, 72.5],
    };
  },
  computed: {
    categories() {
      return categoryService.tree[this.category];
      //return this.$categories[this.category];
    },
    personnelSurvey() {
      return this.surveys?.find(s => s.type === 'PERSONNEL');
    },
    selectedPersonnelSurvey() {
      return this.$store.state.selectedPersonnelSurvey;
    },
    selectedManagementSurvey() {
      return this.$store.state.selectedManagementSurvey;
    },
    managementSurvey() {
      return this.surveys?.find(s => s.type === 'MANAGEMENT');
    },
    managementValue() {
      if (!this.managementSurvey) return -1;
      const values = this.managementSurvey?.calculation?.engineResponse?.oja['culture_leadership']?.avg?.map(c => c.value) || [];
      const value = sum(values) / values.length;
      if (isNaN(value)) return -1;
      return parseFloat(parseFloat(value).toFixed(0));
    },
  },
  methods: {
    goToCategory() {
      this.$router.push({
        name: 'tenant_report_category',
        params: {
          category: this.category,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.culture-chart-holder {
  width: 100%;
}

@media screen and (min-width: 1500px) {
  .culture-chart-holder {
    width: 90%;
    margin: auto;
  }
}

@media screen and (min-width: 2000px) {
  .culture-chart-holder {
    width: 80%;
    margin: auto;
  }
}
</style>
